import React, { useEffect, useRef } from "react";
import { Chart as ChartJS, BarController, LineController, Filler } from "chart.js";

ChartJS.register(BarController, LineController, Filler);

function ChartCanvas({ type, data, options }) {
    const canvasRef = useRef(null);
    const chartRef = useRef(null);

    useEffect(() => {
        if (!canvasRef.current) return undefined;
        chartRef.current = new ChartJS(canvasRef.current, { type, data, options });
        return () => {
            chartRef.current && chartRef.current.destroy();
            chartRef.current = null;
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [type]);

    useEffect(() => {
        const chart = chartRef.current;
        if (!chart) return;
        chart.data = data;
        chart.options = options;
        chart.update();
    }, [data, options]);

    return <canvas ref={canvasRef} role="img" />;
}

export const Bar = (props) => <ChartCanvas type="bar" {...props} />;
export const Line = (props) => <ChartCanvas type="line" {...props} />;

export default ChartCanvas;
